import jamespot, { jArticleLittle, jUserLittle, Model } from 'jamespot-user-api';
import { MentionQuery, TinyMention } from 'jamespot-react-components';
import { DefaultTheme } from 'styled-components';

export const getTinyMCEMentionsQueries: (
    models: Model<string>[],
    theme: DefaultTheme,
    onError: (message?: string) => void,
) => {
    users: MentionQuery;
    tags: MentionQuery;
    contents: MentionQuery;
} = (models, theme, onError) => ({
    users: async (pattern: string) => {
        try {
            const res = await jamespot.user.autocomplete<jUserLittle>(pattern, 5, 'raw-little');
            return res.map((user) => ({
                type: 'autocompleteitem',
                value: `<j-mention data-uri="${user.uri}">@${user.title}</j-mention>&nbsp;`,
                text: user.title,
                icon: `<img src="/imagecache/30x30/user/${user.id}.png?_=${
                    new Date(user.dateModified).getTime() / 1000
                }"/>`,
            }));
        } catch (e: any) {
            onError(e.errorMsg);
            return [];
        }
    },
    tags: async (pattern: string) => {
        try {
            const res = await jamespot.taxonomy.autocompleteList({
                query: pattern,
                limit: 5,
                queryFields: ['title'],
            });
            const results = res.result.data;
            // Ajout d'une entrée pour créer le tag si non trouvé par la recherche
            const toRet: TinyMention[] = results.some((res) => res.title === pattern)
                ? []
                : [
                      {
                          type: 'autocompleteitem',
                          value: `<j-mention data-name="${pattern}">#${pattern}</j-mention>&nbsp;`,
                          text: '+ ' + pattern,
                      },
                  ];
            return [
                ...toRet,
                ...results.map(
                    (concept): TinyMention => ({
                        type: 'autocompleteitem',
                        value: `<j-mention data-uri="${concept.uri}">#${concept.title}</j-mention>&nbsp;`,
                        text: concept.title,
                    }),
                ),
            ];
        } catch (e: any) {
            onError(e.errorMsg);
            return [];
        }
    },
    contents: async (pattern: string) => {
        try {
            const res = await jamespot.article.list<jArticleLittle>({
                query: pattern,
                limit: 5,
                format: 'raw-little',
            });
            return res.result.data.map((article) => {
                const model = models.find((m) => m.type === article.type);
                return {
                    type: 'autocompleteitem',
                    value: `<j-mention data-uri="${article.uri}">!${article.title}</j-mention>&nbsp;`,
                    text: article.title,
                    icon: `<img style="background-color: ${
                        model?.color || theme.color.grey3
                    };" src="/imagestatic/30x30/icons/${model?.icon || 'article'}-white.png\\"/>`,
                };
            });
        } catch (e: any) {
            onError(e.errorMsg);
            return [];
        }
    },
});
